export const highlightedText = (text: string, searchQuery?: string) => {
  if (!searchQuery) return text;

  const lowerText = text.toLowerCase();
  const lowerSearch = searchQuery.toLowerCase();
  const index = lowerText.indexOf(lowerSearch);

  if (index === -1) return text;

  const beforeMatch = text.slice(0, index);
  const match = text.slice(index, index + searchQuery.length);
  const afterMatch = text.slice(index + searchQuery.length);

  return (
    <>
      {beforeMatch}
      <strong>{match}</strong>
      {afterMatch}
    </>
  );
};
